class PdfViewerComponentController {
    constructor($element, $scope, SweetAlert, $timeout) {
        this.ngElement = $element;
        this.scope = $scope;
        this.sweetAlert = SweetAlert;
        this.timeout = $timeout;

        this.currentPdfPage = 1;
        this.drawInProgress = false;

        this._initWatchers();
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.data;
        }, () => {
            if (this.data) {
                this.redrawPdf()
            }
        });
    }

    redrawPdf() {
        if(this.drawInProgress) {
            this.timeout(() => {
                console.log('waiting for redraw');
                this.redrawPdf()
            }, 400);
            return
        }

        this.showPdf();
    }

    _loadPdfDocument() {
        return window.pdfjsLib.getDocument({data: this.data}).promise.then((pdfDocument) => {
            this.pdfDocument = pdfDocument;
        }).catch((reason) => {
            this.sweetAlert.warning('PDF Error', 'There was an error while displaying PDF');
        });
    }

    showCurrentPdfPage() {
        return this.pdfDocument.getPage(this.currentPdfPage).then((pdfPage) => {
            const viewport = pdfPage.getViewport({
                    scale: 1.0
                }),
                canvas = this.ngElement.find('#al_pdf_viewer_canvas')[0];

            canvas.width = viewport.width;
            canvas.height = viewport.height;
            const ctx = canvas.getContext('2d'),
                renderTask = pdfPage.render({
                    canvasContext: ctx,
                    viewport: viewport
                });
            return renderTask.promise;
        });
    }

    showPdf() {
        this.drawInProgress = true
        this._loadPdfDocument().then((pdfDocument) => {
            this.showCurrentPdfPage()
                .then(() => {
                    this.drawInProgress = false
                });
        });
    }

    prevPage() {
        if (this.currentPdfPage <= 1) {
            return;
        }

        this.currentPdfPage -= 1;
        this.showCurrentPdfPage();
    }

    nextPage() {
        if (this.currentPdfPage >= this.pdfDocument.numPages) {
            return;
        }

        this.currentPdfPage += 1;
        this.showCurrentPdfPage();
    }
}

PdfViewerComponentController.$inject = [
    '$element',
    '$scope',
    'SweetAlert',
    '$timeout'
];

/**
 * @ngdoc controller
 * @name components.components:PdfViewerComponentController
 * @restrict EA
 * @element
 *
 * @description
 *
 */
angular
    .module('festzelt-os.components')
    .controller('PdfViewerComponentController', PdfViewerComponentController);



// WEBPACK FOOTER //
// ./src/app/components/components/al-pdf-viewer/controller.js